import { set, update } from "lodash";

const state = {
  tab: 0,
  date: {
    startDate: null,
    endDate: null,
  },
  vehicle: [],
  driver: [],
  selected: [],
  district: [],
  city: null,
  itemSelected: [], // Tambah state untuk menyimpan item yang dipilih di table-new
  transportPlanFilter: {
    // Filter khusus untuk transport plan table-new
    dates: {
      startDate: new Date(),
      endDate: new Date(),
    },
  },
};

const mutations = {
  setTab(state, val) {
    state.tab = val;
  },
  setDate(state, val) {
    state.date = val;
  },
  setVehicle(state, val) {
    state.vehicle = val;
  },
  setDriver(state, val) {
    state.driver = val;
  },
  setDistrict(state, val) {
    state.district = val;
  },
  setCity(state, val) {
    state.city = val;
  },
  setSelected(state, val) {
    state.selected = val;
    // console.log("selected", state.selected);
  },
  removeSelected(state, val) {
    //remove val from selected
    state.selected = state.selected.filter(
      (item) => item.delivery_order_id !== val.delivery_order_id
    );
  },
  addSelected(state, val) {
    state.selected.push(val);
  },
  clearSelected(state) {
    // Clear all selected items
    state.selected = [];
  },
  setShipment(state, val) {
    state.shipment = val;
  },
  setTransportPlanFilterDates(state, val) {
    state.transportPlanFilter.dates = val;
  },
  setItemSelected(state, val) {
    state.itemSelected = val;
  },
  removeItemSelected(state, val) {
    // Remove val from selectedNew
    state.itemSelected = state.itemSelected.filter(
      (item) => item.id !== val.id
    );
  },
  addItemSelected(state, val) {
    console.log("test item add", state, val);
    // Cek apakah item sudah ada untuk menghindari duplikasi
    const exists = state.itemSelected.find((item) => item.id === val.id);
    if (!exists) {
      state.itemSelected.push(val);
    }
  },
  clearItemSelected(state) {
    state.itemSelected = [];
  },
};

const actions = {
  updateTab({ commit }, val) {
    commit("setTab", val);
  },
  updateDate({ commit }, val) {
    commit("setDate", val);
  },
  updateVehicle({ commit }, val) {
    commit("setVehicle", val);
  },
  updateDriver({ commit }, val) {
    commit("setDriver", val);
  },
  updateSelected({ commit }, val) {
    commit("setSelected", val);
  },
  updateDistrict({ commit }, val) {
    commit("setDistrict", val);
  },
  updateCity({ commit }, val) {
    commit("setCity", val);
  },
  updateTransportPlanFilterDates({ commit }, val) {
    commit("setTransportPlanFilterDates", val);
  },
  updateItemSelected({ commit }, val) {
    commit("setItemSelected", val);
  },
};

const getters = {
  getTransportPlanFilterDates: (state) => state.transportPlanFilter.dates,
  getTransportPlanFilter: (state) => state.transportPlanFilter,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
